import { ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { OnInit } from '@angular/core';
import { UiStateStore } from '../../../services/stores/ui-state.store';
import { environment } from '../../../../environments/environment';
// import { OktaAuthService } from '@okta/okta-angular';
import { OrganizationStore } from '../../../services/stores/organization.store';
import { BaseComponent } from '../../base/base.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotificationType } from 'angular2-notifications';
import { OrganizationModel } from '../../../models/organization.model';
import { AlertService } from '../../../services/alert.service';
import { Helper } from '../../../services/helper.service';
import { UserService } from '../../../services/user.service';
import { RecaptchaService } from '../../../services/helpers/recaptcha.service';

@Component({
  selector: 'app-login',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css'],
  standalone: false,
})
export class SignUpComponent extends BaseComponent implements OnInit {
  organization: any;
  signUpForm!: FormGroup;
  currentTermsVersion = 0;
  version = '';
  public isThirdPartyLoginAllow = true;
  isAuthenticated = false;
  isServerProcessing = false;
  serverError: string = '';
  showConfirmationMessage = false;

  constructor(
    private userService: UserService,
    private router: Router,
    private fb: FormBuilder,
    // public oktaAuth: OktaAuthService,
    private alertService: AlertService,
    private organizationStore: OrganizationStore,
    private helperService: Helper,
    private cdr: ChangeDetectorRef,
    private uiStateStore: UiStateStore,
    private recaptchaService: RecaptchaService
  ) {
    super();
    this.version = environment.version;
    // this.oktaAuth.$authenticationState.subscribe((isAuthenticated: boolean) => (this.isAuthenticated = isAuthenticated));
  }

  ngOnInit() {
    if (this.userService.isUserLoggedIn) {
      this.router.navigate(['dashboard']);
    }
    this.createForm();
    this.subscribers.isServerProcessing = this.helperService.isServerProcessing.subscribe((data) => {
      this.isServerProcessing = data;
      this.cdr.detectChanges();
    });
    this.subscribers.formChanges = this.signUpForm.valueChanges.subscribe(() => {
      this.serverError = '';
    });
  }

  createForm() {
    this.signUpForm = this.fb.group({
      organisation: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(100), Validators.pattern(/^[a-z0-9-_!()&' ]+$/i)]],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      phone: '',
      emailAddress: ['', [Validators.email, Validators.required]],
      agreeTerms: [false, Validators.requiredTrue],
      // captcha: ['', Validators.required],
    });
  }

  async onSubmit() {
    this.serverError = '';
    if (this.signUpForm.invalid) {
      this.alertService.alert(NotificationType.Error, 'Please fill in all required fields correctly.', true);
      return;
    }

    this.isServerProcessing = true;
    try {
      const token = await this.recaptchaService.execute('SIGNUP');
      this.save(token);
    } catch (err) {
      this.isServerProcessing = false;
      this.serverError = 'CAPTCHA verification failed, please try again';
      this.alertService.alert(NotificationType.Error, 'CAPTCHA verification failed, please try again', true);
    }
  }

  save(recaptchaToken: string) {
    this.organization = this.prepareSaveOrganization();
    this.uiStateStore.startBackendAction('Adding organisation details...');
    this.isServerProcessing = true;
    this.subscribers.addOrganization = this.organizationStore.$addOrganizationFromSignUp(this.organization, recaptchaToken).subscribe({
      next: (response) => {
        if (response) {
          this.isServerProcessing = false;
          this.signUpForm.markAsPristine();
          this.uiStateStore.endBackendAction('Done!');
          this.alertService.alert(NotificationType.Success, 'Sign Up Successful, please check your email for a confirmation link', true);
          this.showConfirmationMessage = true;
        } else {
          this.isServerProcessing = false;
          this.uiStateStore.endBackendAction('');
          this.alertService.alert(NotificationType.Error, 'Error signing up, please try again or contact support', true);
        }
      },
      error: (err) => {
        this.isServerProcessing = false;
        this.uiStateStore.endBackendAction('');
        if (typeof err?.error === 'string') {
          this.serverError = err.error;
        } else if (err?.error?.error) {
          this.serverError = err.error.error;
        } else {
          this.serverError = 'Error signing up, please try again or contact support';
        }
      },
    });
  }

  resetPassword() {
    this.router.navigate(['/password-reset']);
  }

  goToLogin() {
    this.router.navigate(['/']);
  }

  prepareSaveOrganization() {
    const formModel = this.signUpForm.value;
    const saveOrganization: OrganizationModel = new OrganizationModel({
      id: '',
      logoBase64: '',
      name: formModel.organisation,
      description: '',
      address: '',
      bannerText: '',
      announcementText: '',
      phone: formModel.phone,
      timeZone: '',
      isActive: true,
      showOrgNameInHeader: true,
      timeOut: '15 minutes',
      edition: 'Base',
      allowLocalLogin: true,
      allowThirdPartyLogin: false,
      thirdPartyLoginProvider: '',
      businessContact: {
        firstName: formModel.firstName,
        lastName: formModel.lastName,
        email: formModel.emailAddress,
        phone: formModel.phone,
      },
      technicalContact: {
        firstName: formModel.firstName,
        lastName: formModel.lastName,
        email: formModel.emailAddress,
        phone: formModel.phone,
      },
      country: '',
      city: '',
    });

    return saveOrganization;
  }

}

